"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutocompleteAddressResponseAddressesToJSON = exports.AutocompleteAddressResponseAddressesFromJSONTyped = exports.AutocompleteAddressResponseAddressesFromJSON = void 0;
function AutocompleteAddressResponseAddressesFromJSON(json) {
    return AutocompleteAddressResponseAddressesFromJSONTyped(json, false);
}
exports.AutocompleteAddressResponseAddressesFromJSON = AutocompleteAddressResponseAddressesFromJSON;
function AutocompleteAddressResponseAddressesFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'formattedAddress': json['formattedAddress'],
        'placeId': json['placeId'],
    };
}
exports.AutocompleteAddressResponseAddressesFromJSONTyped = AutocompleteAddressResponseAddressesFromJSONTyped;
function AutocompleteAddressResponseAddressesToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'formattedAddress': value.formattedAddress,
        'placeId': value.placeId,
    };
}
exports.AutocompleteAddressResponseAddressesToJSON = AutocompleteAddressResponseAddressesToJSON;
